module.exports = __webpack_public_path__ + "img/bg_nubi_dark_white.e3f0adcf.jpg";